import { render, staticRenderFns } from "./DetailsHistoryByType.vue?vue&type=template&id=7ae06eaa"
import script from "./DetailsHistoryByType.vue?vue&type=script&lang=js"
export * from "./DetailsHistoryByType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports